import { z } from 'zod';
import { MemberDisplayNameSchema } from './family-requests.js';
import { userIdSchema } from './user-id.js';
// ---------------------------------------------------------------------------
// Family
// ---------------------------------------------------------------------------
export const FamilySchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1),
    created_by: userIdSchema,
    created_at: z.string().datetime(),
});
// ---------------------------------------------------------------------------
// Family Member
// ---------------------------------------------------------------------------
export const FamilyMemberRoleSchema = z.enum(['admin', 'member']);
export const FamilyMemberStatusSchema = z.enum(['active', 'invited', 'inactive']);
export const FamilyMemberSchema = z.object({
    id: z.string().uuid(),
    family_id: z.string().uuid(),
    /** `null` for a member without an account, until an invitation attaches one. */
    user_id: userIdSchema.nullable(),
    display_name: MemberDisplayNameSchema.nullable(),
    role: FamilyMemberRoleSchema,
    status: FamilyMemberStatusSchema,
    joined_at: z.string().datetime(),
    /** A child of the family: the menu composer leans towards dishes that suit one. */
    is_child: z.boolean().default(false),
});
// ---------------------------------------------------------------------------
// Dietary Preferences
// ---------------------------------------------------------------------------
export const DietaryPreferencesSchema = z.object({
    id: z.string().uuid(),
    member_id: z.string().uuid(),
    vegetarian: z.boolean().default(false),
    vegan: z.boolean().default(false),
    gluten_free: z.boolean().default(false),
    lactose_free: z.boolean().default(false),
    allergies: z.array(z.string()).default([]),
    dislikes: z.array(z.string().uuid()).default([]),
});
// ---------------------------------------------------------------------------
// Family Invitation
// ---------------------------------------------------------------------------
export const InvitationStatusSchema = z.enum(['pending', 'accepted', 'declined', 'expired']);
export const FamilyInvitationSchema = z.object({
    id: z.string().uuid(),
    family_id: z.string().uuid(),
    email: z.string().email(),
    invited_by: userIdSchema,
    /** The account-less member the invitee will become, when set. */
    member_id: z.string().uuid().nullable(),
    status: InvitationStatusSchema,
    token: z.string(),
    created_at: z.string().datetime(),
    expires_at: z.string().datetime(),
});
//# sourceMappingURL=family.js.map